import TotalPricePreview from './TotalPricePreview.component';

export default TotalPricePreview;